import api from '..'

const myStatistics = () => {
  return api.get('courses/statistics').then(({ data }) => {
    return data
  })
}

export default myStatistics
